import { useState } from 'react';

import { css } from '@emotion/react';
import { HeaderV2Options } from '@type/web/header';

import usePortal from '@lib/hook/usePortal';
import { palette } from '@lib/styles/palette';

import Icon from '@components/common/Icon';
import AppLayout from '@components/web/Layout/AppLayout';
import PrivacyPolicySelectBox from '@components/web/privacy-policy/PrivacyPolicySelectBox';
import { privacyPolicyComponents } from '@components/web/privacy-policy/data/PrivacyPolicyComponents';

const PrivacyPolicy = (): JSX.Element => {
  /** 개인정보처리방침 문서 추가 절차:
   * 1. @components/web/privacy-policy/list 폴더에서 반영 될 내용으로 컴포넌트 생성/추가
   * 2. @components/web/privacy-policy/data/PrivacyPolicyComponents 파일에서
   *    추가 한 컴포넌트 import하기, { key: 시행일자, value: 컴포넌트 } 형태로 추가하기
   */
  const [currentVer, setCurrentVer] = useState<string>(
    Object.keys(privacyPolicyComponents)[0],
  );
  const { PopUp, onShowPopUp, onHidePopUp } = usePortal('dim');

  const onClickHandleChangeVer = (version: string) => {
    setCurrentVer(version);
    onHidePopUp();
    if (typeof window !== 'undefined') {
      scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  const headerOptions: HeaderV2Options = {
    isFixed: {
      pc: false,
      tablet: true,
    },
    isTopPosition: false,
    isShowBackground: true,
    showAppDownloadBtn: false,
    showNavigationBar: [],
    title: {
      text: '개인정보처리방침',
      showTitle: ['mobile', 'tablet', 'desktop'],
    },
  };
  return (
    <AppLayout headerOptions={headerOptions}>
      <main css={{ backgroundColor: '#e1e1e1' }}>
        {privacyPolicyComponents[currentVer]()}
        <div css={selectBtnStyle}>
          <p className="selectBoxLabel">
            &bull; 시행일자 별 개인정보처리방침 보기
          </p>
          <button onClick={onShowPopUp} aria-label="termsVersion">
            <p>{currentVer} 시행</p>
            <Icon icon="arrowDown" size={12} />
          </button>
        </div>
        <PopUp>
          <PrivacyPolicySelectBox
            onHidePopUp={onHidePopUp}
            currentVer={currentVer}
            onClickHandleChangeVer={onClickHandleChangeVer}
          />
        </PopUp>
      </main>
    </AppLayout>
  );
};

export default PrivacyPolicy;

const selectBtnStyle = css`
  width: 100%;
  margin: 0 auto;
  max-width: 750px;
  padding: 0 20px 20px 20px;
  background-color: white;
  font-size: 14px;
  font-weight: 700;
  color: ${palette.gray14};

  .selectBoxLabel {
    margin-bottom: 8px;
  }
  p {
    font-weight: 600;
  }

  button {
    width: 100%;
    height: 48px;
    border: 1px solid ${palette.gray14};
    padding: 14px;
    background-color: ${palette.white};
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
